<app-navigation></app-navigation>
<div *ngIf="christmas" class="snowflakes" aria-hidden="true">
  <div *ngFor="let item of [].constructor(12)" class="snowflake">❅</div>
</div>
<div id="backgroundImage">
  <div id="cotraContainer" class="container">
    <div id="headerContainer" class="row unselectable headline strong">
      <div>{{translation?.LoginHeaderTitleLine1}}</div>
      <div>{{translation?.LoginHeaderTitleLine2}}</div>
    </div>
    <div id="loginContainer" class="row justify-content-center">
      <div class="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-4">
        <form id="loginForm">
          <div class="loginItem unselectable subhead">{{translation?.Login}}</div>
          <mat-form-field class="loginItem">
            <input matInput placeholder="{{translation?.User}}" (keyup.enter)="login()" [(ngModel)]="username" type="text" name="username" required>
          </mat-form-field>
          <mat-form-field class="loginItem">
            <input matInput placeholder="{{translation?.Password}}" (keyup.enter)="login()" [(ngModel)]="password" type="password" name="password" required>
          </mat-form-field>
          <div id="loginButton" class="loginItem subhead whiteText unselectable" (keyup.enter)="login()" (click)="login()">Login</div>
          <p id="registrationLink" class="upperCase unselectable" (click)="openRegistrationForm()">{{translation.Register}}</p>
          <p id="forgotPasswordLink" class="upperCase unselectable" (click)="openResetPasswordForm()">{{translation.ForgotPassword}}?</p>
        </form>
        <ng-template #callDialog>
          <div class="registerForm">
            <h2 matDialogTitle>{{translation.Register}}</h2>
            <mat-form-field class="registerInput">
              <input matInput name="company" type="text" required="required" placeholder="{{translation.Company}}" [(ngModel)]="registrationData.Company">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="additive" type="text" placeholder="{{translation.AdditionalAddress}}" [(ngModel)]="registrationData.Additive">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="streetAndNumber" type="text" required="required" placeholder="{{translation.StreetAndNumber}}" [(ngModel)]="registrationData.StreetAndNumber">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="zip" type="text" required="required" placeholder="{{translation.Zip}}" [(ngModel)]="registrationData.Zip">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="city" type="text" required="required" placeholder="{{translation.City}}" [(ngModel)]="registrationData.City">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="phone" type="text" required="required" placeholder="{{translation.Phone}}" [(ngModel)]="registrationData.Phone">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="email" type="text" required="required" placeholder="{{translation.Email}}" [(ngModel)]="registrationData.Email">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="firstName" type="text" required="required" placeholder="{{translation.FirstName}}" [(ngModel)]="registrationData.FirstName">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="lastName" type="text" required="required" placeholder="{{translation.LastName}}" [(ngModel)]="registrationData.LastName">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="password" type="password" required="required" placeholder="{{translation.Password}}" [(ngModel)]="registrationPassword">
            </mat-form-field>
            <mat-form-field class="registerInput">
              <input matInput name="repeatedPassword" type="password" required="required" placeholder="{{translation.RepeatPassword}}" [(ngModel)]="repeatedPassword">
            </mat-form-field>
            <mat-dialog-actions align="end">
              <button mat-button class="customButton" (click)="cancel()">{{translation.Cancel}}</button>
              <button mat-button class="customButton" (click)="send()">{{translation.Send}}</button>
            </mat-dialog-actions>
          </div>
        </ng-template>
        <ng-template #callPasswordDialog>
          <div style="display: flex; flex-direction: column; min-width: 450px;">
            <h2 matDialogTitle>{{translation.ForgotPassword}}</h2>
            <p>{{translation.PleaseEnterYourEmail}}</p>
            <mat-form-field class="fieldForm">
              <input matInput name="email" type="text" required="required" placeholder="{{translation.Email}}" [(ngModel)]="email">
            </mat-form-field>
            <mat-dialog-actions align="end">
              <button mat-button class="customButton" (click)="cancel()">{{translation.Cancel}}</button>
              <button mat-button class="customButton" (click)="changePassword()">{{translation.Send}}</button>
            </mat-dialog-actions>
          </div>
        </ng-template>
      </div>
    </div>
    <app-logos-with-link-for-darkmode id="logoContainer"></app-logos-with-link-for-darkmode>
  </div>
</div>
<footer class="unselectable">
  <div id="footer" class="container">
    <div class="row justify-content-center smallerText">
      <div>&nbsp;© 2020 COTRA AUTOTRANSPORT AG&nbsp;</div>
      <div>&nbsp;|&nbsp;</div>
      <a class="links upperCase" href="#">{{translation?.Impressum}}</a>
    </div>
  </div>
</footer>
